import {
  View,
  Text,
  StyleSheet,
  Document,
  Page,
  Link,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: "Helvetica",
  },
  section: {
    marginBottom: 2,
  },
  heading: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 16,
    color: "white",
    padding: 8,
    borderRadius: 4,
  },
  bodyText: {
    fontSize: 12,
    marginBottom: 12,
    lineHeight: 1.5,
  },
  emailContainer: {
    marginVertical: 8,
  },
  emailLink: {
    fontSize: 12,
    color: "#ffff",
    textDecoration: "none",
    fontWeight: "bold",
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginVertical: 24,
  },
  downloadBox: {
    borderWidth: 1,
    borderColor: "#0070C0",
    borderRadius: 4,
    padding: 8,
    marginTop: 1,
    width: "100%",
  },
  fileName: {
    fontSize: 12,
    color: "#0070C0",
    textDecoration: "none",
    marginBottom: 4,
    fontWeight: "bold",
  },
  downloadText: {
    fontSize: 10,
    color: "#0070C0",
    letterSpacing: 0.5,
  },
  pageCount: {
    fontSize: 11,
    fontWeight: "500",
    position: "absolute",
    bottom: 15,
    left: "45%",
    textAlign: "center",
  },
});

const ProposalDocument = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Next Steps Section */}
      {/* <View
        style={{
          marginBottom: 5,
          padding: 10,
          borderColor: "#0070C0",
          borderRadius: 4,
          backgroundColor: "#055c9d",
          color: "#FFFFFF",
        }}
      >
        <Text style={styles.heading}>Next Steps</Text>
        <Text style={styles.bodyText}>
          Please click 'approve', or email your Flyover representative with
          approval. We will email you directly with next steps along with a
          completed contract including our contract Terms and Conditions.
        </Text>

        <View style={styles.emailContainer}>
          <Text style={styles.bodyText}>
            If you have any questions about this proposal, or about our services
            please email us at:
          </Text>
          <Link src="mailto:flights@flyover.io" style={styles.emailLink}>
            flights@flyover.io
          </Link>
        </View>

        <Text style={styles.bodyText}>
          and our team will reply within 24 business hours. Flyover appreciates
          the opportunity to submit this proposal and we look forward to hearing
          from you!
        </Text>
      </View> */}

      {/* Terms & Conditions Section */}
      <View style={styles.section}>
        <Text style={styles.heading}>Terms & Conditions</Text>
        <View style={styles.downloadBox}>
          <Link
            src="flyover_data_llc_terms_conditions_to_proposal.pdf"
            style={styles.fileName}
          >
            • flyover_data_llc_terms_conditions_to_proposal.pdf
          </Link>
          <Text style={styles.downloadText}>DOWNLOAD</Text>
        </View>
      </View>
      {/* <Text style={styles.pageCount}>14 of 14</Text> */}
    </Page>
  </Document>
);

export default ProposalDocument;
